/**
 * Created by spepa on 24.10.2022
 */

const DonorProgressWindow = CleverappsWindow.extend({
    onWindowLoaded: function (selected) {
        this.tabsInfo = {};
        this.rewards = {};

        this.configs = cleverapps.achievements.listByActiveExpeditions();
        this.configs.forEach((config, index) => {
            if (cleverapps.achievements.canGiveAchievement(config)) {
                const landmarks = Map2dLocation.currentLocation && Map2dLocation.currentLocation.landmarks;
                if (landmarks) {
                    this.rewards[index] = new Reward("units", config, { toMainWorld: true, withoutDelta: true });
                    this.rewards[index].receiveReward();
                    landmarks.landmarkReceived(config);
                } else {
                    cleverapps.achievements.grant(config.id);
                    this.rewards[index] = true;
                }
            }

            this.tabsInfo[index] = {
                node: Achievements.getIcon(config),
                generator: this.createTab.bind(this, config, this.rewards[index])
            };
        });

        selected = selected || this.findMostProgressed();

        this.selected = this.configs.indexOf(selected);

        this._super({
            styles: cleverapps.styles.DonorProgressWindow,
            title: Messages.get("DonorProgressWindow.title"),
            name: "DonorProgressWindow",
            content: this.createContent(),
            foreground: bundles.windows.frames.window_foreground_png
        });
    },

    findMostProgressed: function () {
        let best = this.configs[0];
        let bestProgress = cleverapps.achievements.getPendingProgress(best);

        for (let i = 1; i < this.configs.length; ++i) {
            const config = this.configs[i];
            const progress = cleverapps.achievements.getPendingProgress(config);
            if (progress > bestProgress) {
                best = config;
                bestProgress = progress;
            }
        }
        return best;
    },

    createTab: function (config, reward) {
        const styles = cleverapps.styles.DonorProgressWindow;
        const tab = new DonorProgressTab(config, reward, this.createListener(this.updateTabsState.bind(this)), this.createListener(this.close.bind(this)));
        tab.setAnchorPoint(0.5, 1);
        tab.setAlignment(styles.content);
        this.content.addChild(tab);
        return tab;
    },

    createContent: function () {
        const styles = cleverapps.styles.DonorProgressWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles);

        const tabs = this.tabs = new Tabs(this.tabsInfo, styles.tabs);
        tabs.setAlignment(styles.tabs);
        content.addChild(tabs);

        tabs.activateTab(this.selected);
        this.updateTabsState();

        return content;
    },

    updateTabsState: function () {
        if (this.configs.length <= 1) {
            this.tabs.setVisible(false);
            return;
        }

        this.configs.forEach((config, index) => {
            this.tabs.setAttention(index, cleverapps.achievements.getPendingProgress(config));
        });
    },

    beforeCloseAnimation: function (callback) {
        const actions = [];

        Object.keys(this.rewards).forEach((index) => {
            actions.push((f) => {
                const activeTab = this.tabs.activateTab(index);
                if (!activeTab) {
                    f();
                } else if (this.rewards[index].collectRewardsAnimation) {
                    this.rewards[index].collectRewardsAnimation(activeTab.getIcon(), {
                        callback: f
                    });
                } else {
                    f();
                }
            });
        });

        cleverapps.focusManager.compound(callback, actions);
    },

    listBundles: function () {
        const resultBundles = ["donor_progress_window", "achievements"];

        const configs = cleverapps.achievements.listByActiveExpeditions();
        const donors = [];

        configs.forEach((config) => {
            if (config.donors) {
                cleverapps.toArray(config.donors).forEach((donor) => {
                    donors.push(UnitsLibrary.LastStage(donor));
                });
            }
        });

        if (configs.length > 0 && configs[0].code && Families[configs[0].code]) {
            resultBundles.push(...Families.listLazyBundles(configs));
        }
        resultBundles.push(...Families.listLazyBundles(donors));

        return resultBundles;
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DONOR_PROGRESS_FONT: {
        name: "default",
        size: 45
    }
});

cleverapps.styles.DonorProgressWindow = {
    width: 920,
    height: 1000,

    tabs: {
        height: 150,
        direction: cleverapps.UI.VERTICAL,
        x: { align: "left", dx: -200 },
        y: { align: "top", dy: -45 }
    },

    content: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
